import React, { Component } from 'react'
import PropTypes from 'prop-types'
import VoicemailButtonBox from './VoicemailButton'
import CallIconBox from './CallIconBox'
import VoicemailDataBox from './VoicemailDataBox'
import { choosePhoneNumberFormatter } from '../../../services/formatters'

class CallListItem extends Component {
  constructor(props) {
    super(props)

    this.state = {
      showVoicemail: false,
    }

    this.handleVoicemailClick = this.handleVoicemailClick.bind(this)
  }

  handleVoicemailClick() {
    const { showVoicemail } = this.state
    this.setState({ showVoicemail: !showVoicemail })
  }

  render() {
    const { showVoicemail } = this.state
    const {
      callData: {
        formattedTime,
        call_start: callStart,
        call_end: callEnd,
        duration,
        name,
        phone,
        direction,
        friendly_extension: extension,
        voicemail,
      },
      handleNameClick,
    } = this.props

    const formatPhoneNumberUS = choosePhoneNumberFormatter('US')

    return (
      <div className={showVoicemail ? 'showVoicemail' : 'callListItem'}>
        <div className="callDataBox">
          <div className="timeDurationBox">
            <h3>{formattedTime}</h3>
            <p>{ duration ? `Duration: ${duration}` : '(Missed)' }</p>
          </div>
          <div className="nameNumberBox">
            <div
              className="name"
              onClick={handleNameClick}
              role="button"
              tabIndex="-1"
            >
              <h3>{name}</h3>
            </div>
            <p>{formatPhoneNumberUS(phone)}</p>
          </div>
          <div className="extensionBox">
            <p>{`Ext: ${extension}`}</p>
          </div>
          <VoicemailButtonBox
            onClick={this.handleVoicemailClick}
            voicemail={voicemail}
            showVoicemail={showVoicemail}
          />
          <CallIconBox
            direction={direction}
            callStart={callStart}
            callEnd={callEnd}
          />
        </div>
        { showVoicemail && <VoicemailDataBox voicemail={voicemail} /> }
      </div>
    )
  }
}

CallListItem.propTypes = {
  callData: PropTypes.object.isRequired,
  handleNameClick: PropTypes.func.isRequired,
}

export default CallListItem



// WEBPACK FOOTER //
// ./src/components/CallLog/CallLogPage/CallListItem.js